<template>
  <div class="registerWarp">
    <ag-backHome></ag-backHome>
      <div class="registerBoxWarp">
        <p class="top">
          <span class="title">注册账号</span>
          <span class="goLogin" @click="goLogin">已有账号,<i class="rgb22713132">立即登录<img src="../../../assets/images/de7a0e.png"
                                                                                      alt=""></i></span>
        </p>
        <div class="registerBox">
          <div class="tabs">
            <div class="tab" @click="type = 0;clearInfo();"><span :class="{active:type==0}">个人注册</span></div>
            <div class="tab" @click="type = 1;clearInfo();"><span :class="{active:type==1}">企业注册</span></div>
          </div>
          <div class="inputBox" v-if="type==0">
            <div class="inputWarp">
              <div class="t2">姓名</div>
              <input type="text" placeholder="输入您的真实姓名" v-model="name">
            </div>
            <div class="inputWarp code">
              <div class="t2">图形验证码</div>
              <input type="text" placeholder="输入图形验证码" v-model="userPicCode">
            </div>
            <picCode class="zcCode" v-on:getCode="setCode"></picCode>
            <div class="inputWarp code">
              <div class="t2">手机号</div>
              <input type="text" placeholder="输入您的手机号" v-model="mobile">
            </div>
            <getPhoneCode v-on:getCode="setCode" :type="1" :phoneNumber="mobile" :regestNumCode="regestNumCode"></getPhoneCode>
            <div class="inputWarp">
              <div class="t2"> 短信验证码</div>
              <input type="password" placeholder="输入短信验证码" v-model="userPhoneCode">
            </div>
            <div class="inputWarp">
              <div class="t2">登录密码</div>
              <input type="password" placeholder="设置登录密码" v-model="password">
            </div>
            <div class="inputWarp">
              <div class="t2">重复登录密码</div>
              <input type="password" placeholder="重复登录密码" v-model="againpassword">
            </div>
          </div>
          <div class="inputBox" v-if="type==1">
            <div class="inputWarp">
              <div class="t2">企业名称</div>
              <input type="text" placeholder="输入企业名称" v-model="companyName">
            </div>
            <div class="inputWarp">
              <div class="t2">经办人名称</div>
              <input type="text" placeholder="输入经办人名称" v-model="name">
            </div>
            <div class="inputWarp code">
              <div class="t2">图形验证码</div>
              <input type="text" placeholder="输入图形验证码" v-model="userPicCode">
            </div>
            <picCode class="zcCode" v-on:getCode="setCode"></picCode>
            <div class="inputWarp code">
              <div class="t2">手机号</div>
              <input type="number" placeholder="输入您的手机号" maxlength="11" v-model="mobile">
            </div>
            <getPhoneCode v-on:getCode="setCode" :regestNumCode="regestNumCode" :phoneNumber="mobile" :type="1"></getPhoneCode>

            <div class="inputWarp">
              <div class="t2">短信验证码</div>
              <input type="password" placeholder="输入短信验证码" v-model="userPhoneCode">
            </div>
            <div class="inputWarp">
              <div class="t2">登录密码</div>
              <input type="password" placeholder="设置登录密码" v-model="password">
            </div>
            <div class="inputWarp">
              <div class="t2">重复登录密码</div>
              <input type="password" placeholder="重复登录密码" v-model="againpassword">
            </div>
          </div>
          <div class="txt"@click="agree = !agree"><i class="checkBox" :class="{'active':agree}"></i>我已阅读并同意<span>《ABSign服务协议》</span>和 <span>《隐私政策》</span></div>
          <div class="txt" @click="isRK = !isRK"><i class="checkBox" :class="{'active':isRK}"></i>认可使用 ASSign电子合同平台作为签订包括协议在内但不仅限于协议的方式</div>
          <div class="loginBtn" @click="regeist">立即注册</div>
        </div>
      </div>
    <ag-footer></ag-footer>
  </div>
</template>
<script type="text/ecmascript-6">
  import picCode from '../../modules/picCode.vue'
  import getPhoneCode from '../../modules/phoneCode.vue'

  export default {
    data() {
      return {
        companyName: '',
        mobile: '',
        name: '',
        userPicCode: '',
        password: '',
        type: 0,
        picCode: '',
        userPhoneCode: '',
        phoneCode: '',
        regestNumCode:0,
        system:'',
        isRK:true,
        agree:true,
        againpassword:''
      }
    },
    methods: {
      regeist(type) {
        let _this = this;
        if(_this.name == ''){
          this.$message({
            message: '请填写您的姓名',
            type: 'warning'
          });
          return;
        }
        else if(_this.mobile ==''){
          this.$message({
            message: '请填写您的手机号',
            type: 'warning'
          });
          return;
        }
        else if(_this.againpassword ==''){
          this.$message({
            message: '请输入重复密码',
            type: 'warning'
          });
          return;
        }
        else if(_this.againpassword != _this.password){
          this.$message({
            message: '请再次填写密码',
            type: 'warning'
          });
          return;
        }
        else if(_this.userPicCode == ''){
          this.$message({
            message: '请填写您的图片中的验证码',
            type: 'warning'
          });
          return;
        }
        else if(_this.userPhoneCode == ''){
          this.$message({
            message: '请填写您的手机验证码',
            type: 'warning'
          });
          return;
        }
        else if(_this.password == ''){
          this.$message({
            message: '请填写您的手机号',
            type: 'warning'
          });
          return;
        }
        else if(_this.companyName=='' && _this.type ==1){
          this.$message({
            message: '请填写公司名称',
            type: 'warning'
          });
          return;
        }
        else if(_this.picCode!=_this.userPicCode){
          this.$message({
            message: '图形验证码错误，请重新输入!',
            type: 'warning'
          });
          return;
        }
        else if(_this.system!='请求成功' &&_this.system!=''){
          this.$message({
            message: _this.system,
            type: 'warning'
          });
          return;
        }
        _this.ajpost('/api/account/register', {
          code: _this.userPhoneCode,
          companyName: (_this.companyName==''?0:_this.companyName),
          mobile: _this.mobile,
          name: _this.name,
          password: _this.password,
          type: _this.type
        }, function (data) {
          if(data.code ==1){
            _this.$message({
              message: data.msg,
              type: 'warning'
            });
          }else {
            _this.$message({
              message: '注册成功!',
              type: 'success'
            });
            _this.$router.push('/login')
          }
        })
      },
      goLogin(){
        this.$router.push('/login')
      },
      setCode(data) {
        if (data.type == 'picCode') {
          this.picCode = data.code;
        } else {
          this.system = data.code;
        }
      },
      clearInfo() {
        this.regestNumCode = this.regestNumCode+1
        this.companyName = '';
        this.mobile = '';
        this.name = '';
        this.userPicCode = '';
        this.password = '';
        this.userPhoneCode = '';
      }
    },
    components: {
      picCode, getPhoneCode
    }
  }
</script>
<style>
  @import "../../../assets/less/register.css";
</style>



// WEBPACK FOOTER //
// src/components/home/register/register.vue